import { Component, OnInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
//import * as AOS from 'aos';
import { from } from 'rxjs';
import { LinkService } from '../../../_services/langhfre.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-nit',
  templateUrl: './nit.component.html',
  styleUrls: ['./nit.component.scss']
})
export class NitComponent implements OnInit {

  email: any;
  // emailEnterprise : FormGroup;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  constructor(
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private _renderer2: Renderer2, 
    @Inject(DOCUMENT) private _document: Document,
    private router: Router,
    public loadScript: LoadScriptService
  ) {
    
  }

  ngOnInit(): void {
    this.titleService.setTitle('日本工業大学様　学術英語執筆スキル向上のためTrinkaを導入');
    this.metaTagService.updateTag({ name: 'description', content: "日本工業大学英語学習サポートセンター様にて、学生および教職員の皆様の学術英語執筆スキルアップのサポートを目的として、Trinkaを導入いただきました。" });
    this.metaTagService.updateTag({ property: 'og:title', content: '日本工業大学様　学術英語執筆スキル向上のためTrinkaを導入' });
    this.metaTagService.updateTag({ property: 'og:description', content: "日本工業大学英語学習サポートセンター様にて、学生および教職員の皆様の学術英語執筆スキルアップのサポートを目的として、Trinkaを導入いただきました。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/case-study/nit' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '日本工業大学様　学術英語執筆スキル向上のためTrinkaを導入' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "日本工業大学英語学習サポートセンター様にて、学生および教職員の皆様の学術英語執筆スキルアップのサポートを目的として、Trinkaを導入いただきました。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/case-study/nit' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/case-study/nit' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/case-study/nit' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/case-study/nit' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/case-study/nit' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/case-study/nit' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/case-study/nit' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/case-study/nit' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/case-study/nit' });
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  

}
